document.addEventListener('DOMContentLoaded', function () {
  if (window.screen.width < 800) {
    // *.*.*.*.*.*.*.*.*.*.* START OF MENU *.*.*.*.*.*.*.*.*.*.* 
    var menu = document.querySelector('.main_header .menu_icon');
    var closeButton = document.querySelector('.close_menu');
    var menuModal = document.querySelector('.main_header .menu_modal');

    menu.addEventListener('click', toggleMenu);
    closeButton.addEventListener('click', closeMenu);
    menuModal.addEventListener('click', function (event) {
      if (!event.target.closest('.nav_toggle')) {
        closeMenu();
      }
    });

    function toggleMenu() {
      if (menuModal.classList.contains('show_menu')) {
        closeMenu();
      } else {
        menuModal.classList.add('show_menu');
        closeButton.classList.remove('hidden_button');
      }
    }

    function closeMenu() {
      menuModal.classList.remove('show_menu');
      closeButton.classList.add('hidden_button');
    }
    // *.*.*.*.*.*.*.*.*.*.* END OF MENU *.*.*.*.*.*.*.*.*.*.*
    // *.*.*.*.*.*.*.*.*.*.* SUB_MENU *.*.*.*.*.*.*.*.*.*.*
    var menuButtons = document.querySelectorAll('.sub_menu_btn');
    menuButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var subMenu = btn.nextElementSibling;
        if (subMenu) {
          subMenu.classList.toggle('sub_menu_show');

          if (subMenu.classList.contains('sub_menu_show')) {
            btn.style.transform = 'rotate(0)';
            btn.style.top = '-3px';
          } else {
            btn.style.transform = 'rotate(90deg)';
            btn.style.top = '7px';
          }
        }
      });
    });
    // *.*.*.*.*.*.*.*.*.*.* END OF SUB_MENU *.*.*.*.*.*.*.*.*.*.*
  }
  // *.*.*.*.*.*.*.*.*.*.* SEARCH *.*.*.*.*.*.*.*.*.*.*
  document.getElementById("search_icon").addEventListener("click", function () {
    const getSearch = document.getElementById("search_modal");
    const display = window.getComputedStyle(getSearch).visibility;
    if (display === "hidden") {
      getSearch.style.visibility = "visible";
      getSearch.style.opacity = "1";
    } else {
      getSearch.style.visibility = "hidden";
      getSearch.style.opacity = "0";
    }
  });
  // ************* close search ************
  document.getElementById("close_search").addEventListener("click", function () {
    const getSearch = document.getElementById("search_modal");
    const display = window.getComputedStyle(getSearch).visibility;
    if (display === "hidden") {
      getSearch.style.visibility = "visible";
      getSearch.style.opacity = "1";
    } else {
      getSearch.style.visibility = "hidden";
      getSearch.style.opacity = "0";
    }
  });
  var modal = document.getElementById("search_modal");
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.visibility = "hidden";
      modal.style.opacity = "0";
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF SEARCH *.*.*.*.*.*.*.*.*.*.*
  // *.*.*.*.*.*.*.*.*.*.* LIKE NEWS *.*.*.*.*.*.*.*.*.*.*
  function toPersianNumber(number) {
    const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
    return number.toString().replace(/\d/g, (digit) => persianDigits[digit]);
  }
  var rateNewsElements = document.getElementsByClassName("rate_news");
  Array.prototype.forEach.call(rateNewsElements, function (element) {
    element.addEventListener("click", function () {
      fetch("https://blog.gerami.com/rates/score/?type=%2B&object_master_id=" + newsMasterIdForRate)
        .then(function (response) {
          if (response.status == 200) {
            response.json().then(function (newScore) {
              var likeNumberSpan = element.querySelector(".like_number");
              likeNumberSpan.innerHTML = toPersianNumber(newScore.plus);
              var visibleHeart = element.querySelector(".heart:not(.hidden)");
              var hiddenHeart = element.querySelector(".hidden");
              visibleHeart.classList.add("hidden");
              hiddenHeart.classList.remove("hidden");
              var errorMessage = element.querySelector(".error_message");
              if (errorMessage) {
                errorMessage.classList.remove("hidden_error");
              }
            });
          } else {
            var errorMessage = element.querySelector(".error_message");
            if (errorMessage) {
              errorMessage.classList.add("hidden_error");
              setTimeout(function () {
                errorMessage.classList.remove("hidden_error");
              }, 3000);
            }
          }
        })
    });
  });
  // *.*.*.*.*.*.*.*.*.*.* END OF LIKE NEWS *.*.*.*.*.*.*.*.*.*.*
  // *.*.*.*.*.*.*.*.*.*.* START OF light Gallery *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelectorAll('.album_list')) {
    var gallery = document.querySelectorAll(".album_list");
    gallery.forEach(function (pic) {
      lightGallery(pic, {
        speed: 500,
        plugins: [lgThumbnail],
        thumbnail: true

      });
    });
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF light Gallery *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* Responsive table *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector(".ck_editor")) {
    var tables = document.querySelectorAll(".ck_editor table");
    tables.forEach(function (table) {
      var parentTable = document.createElement('div');
      parentTable.classList.add("table_res");
      document.querySelector(".ck_editor").replaceChild(parentTable, table);
      parentTable.appendChild(table);
    });
  }

  // *.*.*.*.*.*.*.*.*.*.* START OF tiny url *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector(".short_link")) {
    var shortLink = document.querySelector(".short_link");
    if (shortLink) {
      shortLink.addEventListener("click", function (event) {
        event.preventDefault();
        var temp = document.getElementById("short_link_copy");
        temp.select();
        document.execCommand("copy");
        document.querySelector(".copied").style.display = "block";
        setTimeout(function () {
          document.querySelector(".copied").style.display = "none";
        }, 1500);
      });
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF tiny url *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // ---- START OF COMMENT NEWS AJAX ----
  if (document.getElementById('comment_list_ajax')) {
    const commentList = document.getElementById('comment_list_ajax');
    const loadMoreBtn = document.getElementById('load_more_comment');
    let currentPage = 1;
    // Initialize limit comment number
    const limitPage = 5;
    if (news_comment < limitPage) loadMoreBtn.remove();

    // Function to format date to YYYY-MM-DD
    function formatDate(dateString) {
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];  // Extracts the date part (YYYY-MM-DD)
    }

    const loadMoreComments = () => {
      fetch(`/comments/ajaxCommentList?newsId=${news_id}&page=${currentPage}&limit=${limitPage}`)
        .then(response => response.json())
        .then(data => {
          if (!data || data.length < limitPage) loadMoreBtn.style.display = 'none';
          if (data) {
            data.forEach(comment => {
            const renderChildren = children => children ? `<ul>${children.map(child => `
            <li>
                <div class="comment_list_user">
                  <p>${child.name || window.i18n.commentUnknown}</p>
                  <div class="comment_data">
                    <span class="comment_published">
                      <time datetime="${child.creation}">${formatDate(child.date)}</time>
                    </span>
                    <div class="icons">
                      <button aria-label="like" onclick="Rate.plus(${child.master_id})" class="like">
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#239F40" d="M14.36 14.23a3.76 3.76 0 0 1-4.72 0a1 1 0 0 0-1.28 1.54a5.68 5.68 0 0 0 7.28 0a1 1 0 1 0-1.28-1.54M9 11a1 1 0 1 0-1-1a1 1 0 0 0 1 1m6-2a1 1 0 1 0 1 1a1 1 0 0 0-1-1m-3-7a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8a8 8 0 0 1-8 8"/></svg>
                        <span id="rateplus${child.master_id}">${child.plus || 0}</span>
                      </button>
                      <button aria-label="dislike" onclick="Rate.minus(${child.master_id})" class="dislike">
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"/><path fill="#DA0000" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16m0 9c1.267 0 2.427.473 3.308 1.25a1 1 0 1 1-1.324 1.5A3 3 0 0 0 12 15c-.761 0-1.455.282-1.984.75a1 1 0 1 1-1.323-1.5A5 5 0 0 1 12 13M8.5 8a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m7 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3"/></g></svg>
                        <span id="rateminus${child.master_id}">${child.minus || 0}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="matn_comment">
                  <p>${child.message}</p>
                </div>
                <div class="comment_reply">
                  <button aria-label="replay" onclick="setCommentParentId(${child.id})" class="reply">${window.i18n.commentReply}</button>
                </div>
              </li>`).join('')}</ul>` : '';

            commentList.innerHTML += `
            <li>
              <div class="comment_list_user">
                <p>${comment.name || window.i18n.commentUnknown}</p>
                <div class="comment_data">
                  <span class="comment_published">
                    <time datetime="${comment.creation}">${formatDate(comment.date)}</time>
                  </span>
                  <div class="icons">
                    <button aria-label="like" onclick="Rate.plus(${comment.master_id})" class="like">
                    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#239F40" d="M14.36 14.23a3.76 3.76 0 0 1-4.72 0a1 1 0 0 0-1.28 1.54a5.68 5.68 0 0 0 7.28 0a1 1 0 1 0-1.28-1.54M9 11a1 1 0 1 0-1-1a1 1 0 0 0 1 1m6-2a1 1 0 1 0 1 1a1 1 0 0 0-1-1m-3-7a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8a8 8 0 0 1-8 8"/></svg>
                    <span id="rateplus${comment.master_id}">${comment.plus || 0}</span>
                    </button>
                    <button aria-label="dislike" onclick="Rate.minus(${comment.master_id})" class="dislike">
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"/><path fill="#DA0000" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16m0 9c1.267 0 2.427.473 3.308 1.25a1 1 0 1 1-1.324 1.5A3 3 0 0 0 12 15c-.761 0-1.455.282-1.984.75a1 1 0 1 1-1.323-1.5A5 5 0 0 1 12 13M8.5 8a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3m7 0a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3"/></g></svg>

                    <span id="rateminus${comment.master_id}">${comment.minus || 0}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="matn_comment">
                <p>${comment.message}</p>
                ${comment.children === null || comment.children.length === 0 ? '' : renderChildren(comment.children)}
              </div>
              <div class="comment_reply">
                <button aria-label="replay" onclick="setCommentParentId(${comment.id})" class="reply">${window.i18n.commentReply}</button>
              </div>
            </li>`;
          });
          currentPage++;
        }
      })
      .catch(error => console.error(error));
    };

    loadMoreComments();
    loadMoreBtn.addEventListener('click', loadMoreComments);
  }


  // ---- END OF COMMENT NEWS AJAX ----
  // ---- INLINE_ADV_&_BOXS ---- 
  var countP = document.querySelectorAll('#ck_editor p:not(table p, blockquote p)');
  function insertBefore(newNode, dist) {
    dist.parentNode.insertBefore(newNode, dist)
  }
  // *-*-*-*-*-*- AFTER P-2 -*-*-*-*-*-*- //
  if (document.getElementById('table_of_content')) {
    if (countP.length > 1) {
      var adv = document.getElementById('table_of_content');
      insertBefore(adv, countP[1].nextSibling);
    } else {
      document.getElementById('table_of_content').style.display = "none";
    }
  }
  // *-*-*-*-*-*- AFTER P-4 -*-*-*-*-*-*- //
  if (document.getElementById('position_g3')) {
    if (countP.length > 3) {
      var adv = document.getElementById('position_g3');
      insertBefore(adv, countP[3].nextSibling);
    } else {
      document.getElementById('position_g3').style.display = "none";
    }
  }
  // *-*-*-*-*-*- AFTER P-6 -*-*-*-*-*-*- //
  if (document.getElementById('position_g4')) {
    if (countP.length > 5) {
      var adv = document.getElementById('position_g4');
      insertBefore(adv, countP[5].nextSibling);
    } else {
      document.getElementById('position_g4').style.display = "none";
    }
  }
  // ---- END OF INLINE_ADV_&_BOXS ----

  // ---- TABLE_OF_CONTENT TOGGLE ----
  var tableOfContent = document.getElementById('table_of_content');
  if (tableOfContent) {
    var tocHeader = tableOfContent.querySelector('.header_section');
    var tocToggleBtn = tableOfContent.querySelector('.toggle_icon');
    if (tocHeader) {
      tocHeader.addEventListener('click', function () {
        var isCollapsed = tableOfContent.classList.toggle('collapsed');
        if (tocToggleBtn) {
          tocToggleBtn.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
        }
      });
    }
  }
  // ---- END OF TABLE_OF_CONTENT TOGGLE ----
})
